// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.proskins-loading-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-height: 100px;
}

.proskins-loading-spinner {
  display: flex;
  width: 20px;
  height: 20px;
  border: 2px solid var(--border-secondary);
  border-radius: 50%;
  border-top-color: var(--proskins-green);
  animation: proskins-spin 1s ease-in-out infinite;
  margin-right: var(--spacing-sm);
}`, "",{"version":3,"sources":["webpack://./src/components/common/Loading.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,uCAAuC;EACvC,gDAAgD;EAChD,+BAA+B;AACjC","sourcesContent":[".proskins-loading-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  min-height: 100px;\n}\n\n.proskins-loading-spinner {\n  display: flex;\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--border-secondary);\n  border-radius: 50%;\n  border-top-color: var(--proskins-green);\n  animation: proskins-spin 1s ease-in-out infinite;\n  margin-right: var(--spacing-sm);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
